import { Component } from '@angular/core';
import { MetforminComponent } from '@consultation-upsells/metformin/metformin.component';

@Component({
  selector: 'app-metformin-trt',
  imports: [MetforminComponent],
  templateUrl: './metformin-trt.component.html',
})
export class MetforminTrtComponent {}
